export function setUnfriendlyCountriesSearch(state, res) {
  const { data = [] } = res;
  state.unfriendlyCountries = data?.items ?? [];
}
